import { DocumentMapping, WorkflowAction } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const PA_EAST_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Create TE, Assign to MA, Reason-Form Request; Keyword-Faxed Request - Generic, update document name, facility and mark as reviewed",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "Form - Request",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Form - Request",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.TE,
    workflowType: "",
    classification: Classification.ADMIN,
    group: "pediatricassociates-east",
  },
  [Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Create TE, Assign to MA, Reason-Letter Request; Keyword-Faxed Request - Generic, update document name, facility and mark as reviewed",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "Letter of Medical Necessity",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Letter of Medical Necessity",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.TE,
    workflowType: "",
    classification: Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY,
    group: "pediatricassociates-east",
  },
  [Classification.ADMIN_DOH_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Create TE, Assign to MA, Reason-Form Request; Keyword-Faxed Request - Generic, update document name, facility and mark as reviewed",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "Form - DOH Illness Report Form",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Form - DOH Illness Report Form",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.TE,
    workflowType: "",
    classification: Classification.ADMIN_DOH_FORMS,
    group: "pediatricassociates-east",
  },
  [Classification.ADMIN_FMLA_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Create TE, Assign to MA, Reason-Form Request; Keyword-Faxed Request - Generic, update document name, facility and mark as reviewed",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "Form - FMLA",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Form - FMLA",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.TE,
    workflowType: "",
    classification: Classification.ADMIN_FMLA_FORMS,
    group: "pediatricassociates-east",
  },
  [Classification.ADMIN_PATIENT_QUESTIONNAIRE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Assign to PCP if not scored"],
    assignedTo: "Auto-Assign",
    displayName: "Questionnaire - Risk/Safety",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Questionnaire - Risk/Safety",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.ADMIN_PATIENT_QUESTIONNAIRE,
    group: "pediatricassociates-east",
  },
  [Classification.ADMIN_PATIENT_QUESTIONNAIRE_VANDERBILT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Assign to PCP if not scored"],
    assignedTo: "PCP [Identify Patient's PCP]",
    displayName: "Screening - Vanderbilt Questionnaire",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Screening - Vanderbilt Questionnaire",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.ADMIN_PATIENT_QUESTIONNAIRE_VANDERBILT,
    group: "pediatricassociates-east",
  },
  [Classification.ADMIN_PCP_ACKNOWLEDGEMENT_FORM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Document Processing, Generic",
    displayName: "PCP Acknowledgement Form",
    documentLabel: "{{ dateOfDocument YYYY/MM/DD }}, PCP Acknowledgement Form",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.ADMIN_PCP_ACKNOWLEDGEMENT_FORM,
    group: "pediatricassociates-east",
  },
  [Classification.CARE_PLAN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Add within the template if it is a ST, OT, or PT Duplicate."],
    assignedTo: "Montes, Maria",
    displayName: "Duplicate POC",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Duplicate POC",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.CARE_PLAN,
    group: "pediatricassociates-east",
  },
  [Classification.CLEARANCE_REQUEST_PRE_OP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Attach to Referral if available; Create TE, Assign to MA, Reason-Form Request; Keyword-Form Request: PreOp Clearance, update document name, facility",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "Pre-Op Request",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, Pre-Op Request",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.TE,
    workflowType: "",
    classification: Classification.CLEARANCE_REQUEST_PRE_OP,
    group: "pediatricassociates-east",
  },
  [Classification.CONSENT_FOR_RECORDS_SPECIALIST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Auto-Assign",
    displayName: "Referrals - Consent for Records - Specialist",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Referrals - Consent for Records - Specialist",
    folder: "Referral-Consult Notes",
    folderMapping: "Referral-Consult Notes",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.CONSENT_FOR_RECORDS_SPECIALIST,
    group: "pediatricassociates-east",
  },
  [Classification.DME_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Create TE, Assign to MA, Reason-DME Request; Keyword-Faxed Request - Generic, update document name, facility and mark as reviewed",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "DME Request",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, DME Request {{ dmeType }}",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.TE,
    workflowType: "",
    classification: Classification.DME_REQUEST,
    group: "pediatricassociates-east",
  },
  [Classification.DME_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Create TE, Assign to MA, Reason-DME Request; Keyword-Faxed Request - Generic, update document name, facility and mark as reviewed",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "DME Request - Approval Notice",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, DME Request - Approval Notice {{ dmeType }}",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.TE,
    workflowType: "",
    classification: Classification.DME_RESPONSE,
    group: "pediatricassociates-east",
  },
  [Classification.EMERGENCY_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Medical Assistant, Generic",
    displayName: "Emergency Summary",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Emergency Summary",
    folder: "Hospital/ER/Urgent Care Records > Hospital-ER-UC Summary",
    folderMapping: "Hospital/ER/Urgent Care Records > Hospital-ER-UC Summary",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.EMERGENCY_SUMMARY,
    group: "pediatricassociates-east",
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "If an order is not available to attach, upload document, assign to patient PCP, and ensure document is marked UNreviewed.",
      "If a matching order is available, attach document (unless the matching order has already been reviewed). If the matching order HAS been reviewed, add note to document description indicating that the document could not be attached to the matching order and mark document reviewed. If able to attach to order, assign the matched order to Montes,Maria, mark high priority if follow-up is required, and add Internal Note. Document should be assigned to the ordering clinician and marked reviewed.",
      "Internal Note: Please see results attached via paperclip icon.",
      "Follow-Up Required: {{ followUpRequired }}",
    ],
    assignedTo: "Ordering Clinician",
    displayName: "Radiology - CT Scan",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Radiology - CT Scan {{ bodyPart }}",
    folder: "Diagnostic Imaging Documents",
    folderMapping: "Diagnostic Imaging Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "pediatricassociates-east",
  },
  [Classification.IMAGING_RESULTS_ECHO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "If an order is not available to attach, upload document, assign to patient PCP, and ensure document is marked UNreviewed.",
      "If a matching order is available, attach document (unless the matching order has already been reviewed). If the matching order HAS been reviewed, add note to document description indicating that the document could not be attached to the matching order and mark document reviewed. If able to attach to order, assign the matched order to Montes,Maria, mark high priority if follow-up is required, and add Internal Note. Document should be assigned to the ordering clinician and marked reviewed.",
      "Internal Note: Please see results attached via paperclip icon.",
      "Follow-Up Required: {{ followUpRequired }}",
    ],
    assignedTo: "Ordering Clinician",
    displayName: "Procedure - Echo Results",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Procedure - Echo Results",
    folder: "Diagnostic Imaging Documents",
    folderMapping: "Diagnostic Imaging Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_ECHO,
    group: "pediatricassociates-east",
  },
  [Classification.IMAGING_RESULTS_EKG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "If an order is not available to attach, upload document, assign to patient PCP, and ensure document is marked UNreviewed.",
      "If a matching order is available, attach document (unless the matching order has already been reviewed). If the matching order HAS been reviewed, add note to document description indicating that the document could not be attached to the matching order and mark document reviewed. If able to attach to order, assign the matched order to Montes,Maria, mark high priority if follow-up is required, and add Internal Note. Document should be assigned to the ordering clinician and marked reviewed.",
      "Internal Note: Please see results attached via paperclip icon.",
      "Follow-Up Required: {{ followUpRequired }}",
    ],
    assignedTo: "Ordering Clinician",
    displayName: "Procedure EKG - Results",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Procedure EKG - Results",
    folder: "Diagnostic Imaging Documents",
    folderMapping: "Diagnostic Imaging Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_EKG,
    group: "pediatricassociates-east",
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "If an order is not available to attach, upload document, assign to patient PCP, and ensure document is marked UNreviewed.",
      "If a matching order is available, attach document (unless the matching order has already been reviewed). If the matching order HAS been reviewed, add note to document description indicating that the document could not be attached to the matching order and mark document reviewed. If able to attach to order, assign the matched order to Montes,Maria, mark high priority if follow-up is required, and add Internal Note. Document should be assigned to the ordering clinician and marked reviewed.",
      "Internal Note: Please see results attached via paperclip icon.",
      "Follow-Up Required: {{ followUpRequired }}",
    ],
    assignedTo: "Ordering Clinician",
    displayName: "Radiology - MRI Results",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Radiology - MRI {{ bodyPart }} Results",
    folder: "Diagnostic Imaging Documents",
    folderMapping: "Diagnostic Imaging Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "pediatricassociates-east",
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "If an order is not available to attach, upload document, assign to patient PCP, and ensure document is marked UNreviewed.",
      "If a matching order is available, attach document (unless the matching order has already been reviewed). If the matching order HAS been reviewed, add note to document description indicating that the document could not be attached to the matching order and mark document reviewed. If able to attach to order, assign the matched order to Montes,Maria, mark high priority if follow-up is required, and add Internal Note. Document should be assigned to the ordering clinician and marked reviewed.",
      "Internal Note: Please see results attached via paperclip icon.",
      "Follow-Up Required: {{ followUpRequired }}",
    ],
    assignedTo: "Ordering Clinician",
    displayName: "Radiology - Ultrasound",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Radiology - Ultrasound {{ bodyPart }}",
    folder: "Diagnostic Imaging Documents",
    folderMapping: "Diagnostic Imaging Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "pediatricassociates-east",
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Attach to Order if available. Ensure that the Received checkbox is selected within the order. If an Order is not available to attach, upload and assign to patient PCP, and marked UNreviewed.",
    ],
    assignedTo: "Ordering Clinician",
    displayName: "Radiology - XRAY Results",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Radiology - XRAY {{ bodyPart }} Results",
    folder: "Diagnostic Imaging Documents",
    folderMapping: "Diagnostic Imaging Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "pediatricassociates-east",
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Auto-Assign",
    displayName: "Insurance ID Card",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Insurance ID Card",
    folder: "Registration Documents > Insurance Documents",
    folderMapping: "Registration Documents > Insurance Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.INSURANCE_CARD,
    group: "pediatricassociates-east",
  },
  [Classification.INSURANCE_COMMUNICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Auto-Assign",
    displayName: "Insurance Communication",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Insurance Communication",
    folder: "Registration Documents > Insurance Documents",
    folderMapping: "Registration Documents > Insurance Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.INSURANCE_COMMUNICATION,
    group: "pediatricassociates-east",
  },
  [Classification.INSURANCE_LETTER_OF_ASSURANCE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Add ChildNet Global Alert"],
    assignedTo: "Auto-Assign",
    displayName: "ChildNet - LOA",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, ChildNet - LOA",
    folder: "Registration Documents > Insurance Documents",
    folderMapping: "Registration Documents > Insurance Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.INSURANCE_LETTER_OF_ASSURANCE,
    group: "pediatricassociates-east",
  },
  [Classification.LAB_RESULTS_BILIRUBIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Attach to Order if available. Ensure that the Received checkbox is selected within the order. If an Order is not available to attach, upload and assign to patient PCP, and marked UNreviewed.",
    ],
    assignedTo: "PCP [Identify Patient's PCP]",
    displayName: "NB Labs - Bilirubin",
    documentLabel: "{{ collectionDate YYYY/MM/DD }}, NB Labs - Bilirubin",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_BILIRUBIN,
    group: "pediatricassociates-east",
  },
  [Classification.LAB_RESULTS_HEARING_TEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Attach to Order if available. Ensure that the Received checkbox is selected within the order. If an Order is not available to attach, upload and assign to patient PCP, and marked UNreviewed.",
    ],
    assignedTo: "PCP [Identify Patient's PCP]",
    displayName: "NB Labs - Hearing Test",
    documentLabel: "{{ collectionDate YYYY/MM/DD }}, NB Labs - Hearing Test",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_HEARING_TEST,
    group: "pediatricassociates-east",
  },
  [Classification.LAB_RESULTS_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Attach to Order if available. Ensure that the Received checkbox is selected within the order. If an Order is not available to attach, upload and assign to patient PCP, and marked UNreviewed.",
    ],
    assignedTo: "PCP [Identify Patient's PCP]",
    displayName: "Lab Results",
    documentLabel: "{{ collectionDate YYYY/MM/DD }}, Lab Results",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_OTHER,
    group: "pediatricassociates-east",
  },
  [Classification.LAB_RESULTS_PATHOLOGY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Attach to Order if available. Ensure that the Received checkbox is selected within the order. If an Order is not available to attach, upload and assign to patient PCP, and marked UNreviewed.",
    ],
    assignedTo: "PCP [Identify Patient's PCP]",
    displayName: "Lab Results - Surgical Pathology Report",
    documentLabel: "{{ collectionDate YYYY/MM/DD }}, Lab Results - Surgical Pathology Report",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_PATHOLOGY,
    group: "pediatricassociates-east",
  },
  [Classification.LAB_RESULTS_PKU]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Attach to Order if available. Ensure that the Received checkbox is selected within the order. If an Order is not available to attach, upload and assign to patient PCP, and marked UNreviewed.",
    ],
    assignedTo: "PCP [Identify Patient's PCP]",
    displayName: "NB Labs - PKU NB Screening",
    documentLabel: "{{ collectionDate YYYY/MM/DD }}, NB Labs - PKU NB Screening",
    folder: "Lab Documents",
    folderMapping: "Lab Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.LAB_RESULTS_PKU,
    group: "pediatricassociates-east",
  },
  [Classification.LEGAL_COURT_DOCUMENTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Create Action using Court Document template, Keyword-Court Document Needs Review, attach document",
    ],
    assignedTo: "Front Office, Generic",
    displayName: "Court Documents",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Court Documents",
    folder: "Registration Documents",
    folderMapping: "Registration Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.ACTION,
    workflowType: "",
    classification: Classification.LEGAL_COURT_DOCUMENTS,
    group: "pediatricassociates-east",
  },
  [Classification.MEDICAL_HISTORY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Auto-Assign",
    displayName: "Previous Medical Records",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, Previous Medical Records",
    folder: "Medical Records > Previous Records",
    folderMapping: "Medical Records > Previous Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_HISTORY,
    group: "pediatricassociates-east",
  },
  [Classification.MEDICAL_HISTORY_IMMUNIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Create TE, Assign to MA, Reason-Historical data; Keyword-Received Immunization Records, update document name, facility and mark as reviewed",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "Immunization Records",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, Immunization Records",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.TE,
    workflowType: "",
    classification: Classification.MEDICAL_HISTORY_IMMUNIZATION,
    group: "pediatricassociates-east",
  },
  [Classification.MEDICAL_HISTORY_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Front Office, Generic",
    displayName: "ROI - Response to Office",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, ROI - Response to Office",
    folder: "Medical Records > Record Release",
    folderMapping: "Medical Records > Record Release",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_HISTORY_RESPONSE,
    group: "pediatricassociates-east",
  },
  [Classification.MEDICAL_RECORD_REQUEST_DOH]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Mark High Priority"],
    assignedTo: "Medical Records, Generic",
    displayName: "Rec Request - Department of Health",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, Rec Request - Department of Health",
    folder: "Medical Records > Record Release",
    folderMapping: "Medical Records > Record Release",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_RECORD_REQUEST_DOH,
    group: "pediatricassociates-east",
  },
  [Classification.MEDICAL_RECORD_REQUEST_HEDIS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Assign to patient account: Ciox Hedis, 2026"],
    assignedTo: "Medical Records, Generic",
    displayName: "Rec Request - CIOX/HEDIS",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, Rec Request - CIOX/HEDIS",
    folder: "Medical Records > Record Release",
    folderMapping: "Medical Records > Record Release",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_RECORD_REQUEST_HEDIS,
    group: "pediatricassociates-east",
  },
  [Classification.MEDICAL_RECORD_REQUEST_LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Mark High Priority"],
    assignedTo: "Medical Records, Generic",
    displayName: "Rec Request - Legal",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, Rec Request - Legal",
    folder: "Medical Records > Record Release",
    folderMapping: "Medical Records > Record Release",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_RECORD_REQUEST_LEGAL,
    group: "pediatricassociates-east",
  },
  [Classification.MEDICAL_RECORD_REQUEST_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ['Add "Record Release on file" to ChildNet global alert'],
    assignedTo: "Auto-Assign",
    displayName: "ChildNet - Record Release (HIPAA B)",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, ChildNet - Record Release (HIPAA B)",
    folder: "Medical Records > Record Release",
    folderMapping: "Medical Records > Record Release",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_RECORD_REQUEST_OTHER,
    group: "pediatricassociates-east",
  },
  [Classification.MEDICAL_RECORD_REQUEST_SSA]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Medical Records, Generic",
    displayName: "Rec Request - SSA (Social Security)",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, Rec Request - SSA (Social Security)",
    folder: "Medical Records > Record Release",
    folderMapping: "Medical Records > Record Release",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_RECORD_REQUEST_SSA,
    group: "pediatricassociates-east",
  },
  [Classification.NOTIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Front Office, Generic",
    displayName: "On-Call Service Message",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, On-Call Service Message",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.NOTIFICATION,
    group: "pediatricassociates-east",
  },
  [Classification.NOTIFICATION_HOSPITAL_FACE_SHEET]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Auto-Assign",
    displayName: "Hospital Outpatient Face Sheet",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Hospital Outpatient Face Sheet",
    folder: "Hospital/ER/Urgent Care Records > Other Hospital Records",
    folderMapping: "Hospital/ER/Urgent Care Records > Other Hospital Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.NOTIFICATION_HOSPITAL_FACE_SHEET,
    group: "pediatricassociates-east",
  },
  [Classification.OPERATION_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Auto-Assign",
    displayName: "Op Note",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Op Note",
    folder: "Procedure Documents",
    folderMapping: "Procedure Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.OPERATION_NOTE,
    group: "pediatricassociates-east",
  },
  [Classification.PHARMACY_RELATED_ALERT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Assign to Medical Assistant, Generic; mark reviewed. Create TE, Assign to Medical Assistant, Generic, Reason-Insurance Communication; Keyword-Faxed Request - Generic",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "RX Potential Gap in Therapy",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, RX Potential Gap in Therapy",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.TE,
    workflowType: "",
    classification: Classification.PHARMACY_RELATED_ALERT,
    group: "pediatricassociates-east",
  },
  [Classification.PHARMACY_RELATED_CLARIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Assign to Medical Assistant, Generic; update document name with medication name and days supply, and mark reviewed. Create TE, Assign to Medical Assistant, Generic, Reason-Rx Refill Request; Keyword-Faxed Request - Generic",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "RX Clarification Notice",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, RX Clarification Notice {{ medicationName }} {{ supplyDuration }}",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: WorkflowAction.TE,
    workflowType: "",
    classification: Classification.PHARMACY_RELATED_CLARIFICATION,
    group: "pediatricassociates-east",
  },
  [Classification.PHARMACY_RELATED_MED_RECONCILIATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "PCP [Identify Patient's PCP]",
    displayName: "RX Med Reconciliation Post-Discharge",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, RX Med Reconciliation Post-Discharge {{ medicationName }}",
    folder: "Prescriptions",
    folderMapping: "Prescriptions",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PHARMACY_RELATED_MED_RECONCILIATION,
    group: "pediatricassociates-east",
  },
  [Classification.PHARMACY_RELATED_MEDICATION_LIST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "PCP [Identify Patient's PCP]",
    displayName: "RX Personal Medication List",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, RX Personal Medication List",
    folder: "Prescriptions",
    folderMapping: "Prescriptions",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PHARMACY_RELATED_MEDICATION_LIST,
    group: "pediatricassociates-east",
  },
  [Classification.PHARMACY_RELATED_REFILL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Assign to Medical Assistant, Generic; update document name with medication name and days supply",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "RX Synagis",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, RX Synagis {{ medicationName }} {{ supplyDuration }}",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PHARMACY_RELATED_REFILL,
    group: "pediatricassociates-east",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Assign to Medical Assistant, Generic; update document name with medication name and days supply",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "Rx Prior Auth Request",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Rx Prior Auth Request {{ medicationName }} {{ supplyDuration }}",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "pediatricassociates-east",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Assign to Medical Assistant, Generic; update document name with medication name and days supply",
    ],
    assignedTo: "Medical Assistant, Generic",
    displayName: "RX Prior Auth Approval",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, RX Prior Auth Approval {{ medicationName }} {{ supplyDuration }}",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "pediatricassociates-east",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "PCP [Identify Patient's PCP]",
    displayName: "Hospital Authorization for Stay",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Hospital Authorization for Stay",
    folder: "Hospital/ER/Urgent Care Records > Other Hospital Records",
    folderMapping: "Hospital/ER/Urgent Care Records > Other Hospital Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "pediatricassociates-east",
  },
  [Classification.PRIOR_AUTHORIZATION_REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Auto-Assign",
    displayName: "Referral Authorization (Approval)",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, Referral Authorization (Approval)",
    folder: "Referral-Consult Notes",
    folderMapping: "Referral-Consult Notes",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PRIOR_AUTHORIZATION_REFERRAL_RESPONSE,
    group: "pediatricassociates-east",
  },
  [Classification.PROCEDURE_SLEEP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Attach to Order if available"],
    assignedTo: "Ordering Clinician",
    displayName: "Procedure - Polysomnogram Results",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Procedure - Polysomnogram Results",
    folder: "Procedure Documents",
    folderMapping: "Procedure Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "Orders WF",
    classification: Classification.PROCEDURE_SLEEP,
    group: "pediatricassociates-east",
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Attach to Referral if available", "If no referral available to attach to, auto-assign"],
    assignedTo: "Ordering Clinician",
    displayName: "Consult - Chrysalis Memo",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Consult - Chrysalis Memo",
    folder: "Referral-Consult Notes",
    folderMapping: "Referral-Consult Notes",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PROGRESS_NOTE,
    group: "pediatricassociates-east",
  },
  [Classification.CONTINUITY_OF_CARE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Medical Assistant, Generic",
    displayName: "Hospital Continuity of Care",
    documentLabel: "{{ dateOfEvent YYYY/MM/DD }}, Hospital Continuity of Care",
    folder: "Hospital/ER/Urgent Care Records > Hospital-ER-UC Summary",
    folderMapping: "Hospital/ER/Urgent Care Records > Hospital-ER-UC Summary",
    inputDate: "Date of Event",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.CONTINUITY_OF_CARE,
    group: "pediatricassociates-east",
  },
  [Classification.REFERRAL_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Document Processing, Generic",
    displayName: "Referral Request",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, Referral Request",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.REFERRAL_REQUEST,
    group: "pediatricassociates-east",
  },
  [Classification.REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "PCP [Identify Patient's PCP]",
    displayName: "Referral - Missed Services",
    documentLabel: "{{ dateReceived YYYY/MM/DD }}, Referral - Missed Services",
    folder: "Referral-Consult Notes",
    folderMapping: "Referral-Consult Notes",
    inputDate: "",
    instructions: null,
    markAsReviewed: false,
    workflowAction: null,
    workflowType: "",
    classification: Classification.REFERRAL_RESPONSE,
    group: "pediatricassociates-east",
  },
} as const;
